import React, { createContext, useState, useContext, useEffect } from "react";
import { calculateDate } from "libs/dateCalculator";
import { estadosSolicitud } from "components/business/estadoSolicitudDropdown/EstadoSolicitudDropdown";
import { Provincia } from "components/business/provinciaSelector/getProvincias";
import { IListItem } from "api/types/originacion/commonTypes";

interface FiltrosContextType {
  search: string;
  setSearch: (value: string) => void;
  fechaDesde: Date;
  fechaHasta: Date;
  estadoSolicitud: string;
  fechaEstado: string;
  provincia: Provincia | null;
  setProvincia: (provincia: Provincia | null) => void;
  currentPage: number;
  rowsPerPage: number;
  setFechaDesde: (date: Date) => void;
  setFechaHasta: (date: Date) => void;
  setEstadoSolicitud: (estado: string) => void;
  setFechaEstado: (fecha: string) => void;
  setCurrentPage: (page: number) => void;
  setRowsPerPage: (rows: number) => void;
  handleChangeInterval: (value: number | null) => void;
  handleChangeStartDate: (date: string) => void;
  handleChangeEndDate: (date: string) => void;
  fechaDesdeUpdate: Date;
  fechaHastaUpdate: Date;
  setFechaDesdeUpdate: (date: Date) => void;
  setFechaHastaUpdate: (date: Date) => void;
  handleChangeIntervalUpdate: (value: number | null) => void;
  handleChangeStartDateUpdate: (date: string) => void;
  handleChangeEndDateUpdate: (date: string) => void;
  searchAnalisis: string;
  setSearchAnalisis: (value: string) => void;
  ITEMS_PER_PAGE_ANALISIS: number[];
  onPageChangeAnalisis: (e: any, n: number) => void;
  onRowsPerPageChangeAnalisis: (e: any) => void;
  currentPageAnalisis: number;
  rowsPerPageAnalisis: number;
  onPageChange: (e: any, n: number) => void;
  onRowsPerPageChange: (e: any) => void;
  ITEMS_PER_PAGE: number[];
  fechaLoteSeleccionada: string;
  setFechaLoteSeleccionada: (value: string) => void;
  cadenaSeleccionada: IListItem | null;
  setCadenaSeleccionada: (value: IListItem | null) => void;
  retailerSeleccionada: IListItem | null;
  setRetailerSeleccionada: (value: IListItem | null) => void;
  searchPlanes: string;
  setSearchPlanes: (value: string) => void;
  lineaPlanesSeleccionada: IListItem;
  setLineaPlanesSeleccionada: (value: IListItem) => void;
  nivelRiesgoSeleccionado: IListItem;
  setNivelRiesgoSeleccionado: (value: IListItem) => void;
  grupoPlanSeleccionado: IListItem;
  setGrupoPlanSeleccionado: (value: IListItem) => void;
  currentPagePlanes: number;
  setCurrentPagePlanes: (page: number) => void;
  rowsPerPagePlanes: number;
  setRowsPerPagePlanes: (rows: number) => void;
  onPageChangePlanes: (e: any, n: number) => void;
  onRowsPerPageChangePlanes: (e: any) => void;
  ITEMS_PER_PAGE_PLANES: number[];
  searchCadenas: string;
  setSearchCadenas: (value: string) => void;
  retailerSeleccionadaCadenas: IListItem | null;
  setRetailerSeleccionadaCadenas: (value: IListItem | null) => void;
  ITEMS_PER_PAGE_CADENAS: number[];
  currentPageCadenas: number;
  rowsPerPageCadenas: number;
  setCurrentPageCadenas: (page: number) => void;
  setRowsPerPageCadenas: (rows: number) => void;
  onPageChangeCadenas: (e: any, n: number) => void;
  onRowsPerPageChangeCadenas: (e: any) => void;
}

const FiltrosContext = createContext<FiltrosContextType | undefined>(undefined);

export const FiltrosProvider: React.FC = ({ children }) => {
  // State for search input Solicitudes
  const [search, setSearch] = useState("");

  // State for search input Análisis
  const [searchAnalisis, setSearchAnalisis] = useState("");

  // State for start and end dates Solicitudes
  const [fechaDesde, setFechaDesde] = useState(calculateDate(new Date(), -30));
  const [fechaHasta, setFechaHasta] = useState(new Date());

  // State for dateUpdate filter Análisis
  const [fechaDesdeUpdate, setFechaDesdeUpdate] = useState(
    calculateDate(new Date(), -30),
  );
  const [fechaHastaUpdate, setFechaHastaUpdate] = useState(new Date());

  // State for estadoSolicitud and fechaEstado
  const [estadoSolicitud, setEstadoSolicitud] = useState(
    estadosSolicitud.Consumo[0].value,
  );
  const [fechaEstado, setFechaEstado] = useState(
    estadosSolicitud.ConsumoYen[0].value,
  );

  // State for provincia filter
  const [provincia, setProvincia] = useState<Provincia | null>(null);

  // State for pagination Solicitudes
  const ITEMS_PER_PAGE = [10, 25, 50, 100];
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(ITEMS_PER_PAGE[0]);

  // State for pagination Análisis
  const ITEMS_PER_PAGE_ANALISIS = [10, 25, 50, 100];
  const [currentPageAnalisis, setCurrentPageAnalisis] = useState(0);
  const [rowsPerPageAnalisis, setRowsPerPageAnalisis] = useState(
    ITEMS_PER_PAGE_ANALISIS[0],
  );

  // State for retailerSeleccionada
  const [retailerSeleccionada, setRetailerSeleccionada] =
    useState<IListItem | null>({ value: 0, label: "Todos" });

  // State for filters in Planes Comerciales
  const ITEMS_PER_PAGE_PLANES = [10, 25, 50, 100];
  const [searchPlanes, setSearchPlanes] = useState("");
  const [lineaPlanesSeleccionada, setLineaPlanesSeleccionada] =
    useState<IListItem>({ value: 0, label: "Todas" });
  const [nivelRiesgoSeleccionado, setNivelRiesgoSeleccionado] =
    useState<IListItem>({ value: "", label: "Todos" });
  const [grupoPlanSeleccionado, setGrupoPlanSeleccionado] = useState<IListItem>(
    { value: 0, label: "Todos" },
  );
  const [currentPagePlanes, setCurrentPagePlanes] = useState(0);
  const [rowsPerPagePlanes, setRowsPerPagePlanes] = useState(
    ITEMS_PER_PAGE_PLANES[0],
  );

  // State for filters in Cadenas
  const [searchCadenas, setSearchCadenas] = useState("");

  const [retailerSeleccionadaCadenas, setRetailerSeleccionadaCadenas] =
    useState<IListItem | null>({ value: 0, label: "Todos" });

  const ITEMS_PER_PAGE_CADENAS = [10, 25, 50, 100];
  const [currentPageCadenas, setCurrentPageCadenas] = useState(0);
  const [rowsPerPageCadenas, setRowsPerPageCadenas] = useState(
    ITEMS_PER_PAGE_CADENAS[0],
  );

  // Reset currentPage when filters change for Solicitudes
  useEffect(() => {
    setCurrentPage(0);
  }, [estadoSolicitud, fechaDesde, fechaHasta, fechaEstado, provincia, search]);

  // Reset currentPage when filters change for Análisis
  useEffect(() => {
    setCurrentPageAnalisis(0);
  }, [searchAnalisis, fechaDesdeUpdate, fechaHastaUpdate]);

  // Reset currentPage when filters change for Cadenas
  useEffect(() => {
    setCurrentPageCadenas(0);
  }, [searchCadenas, retailerSeleccionadaCadenas]);

  // Reset currentPage when filters change for Planes Comerciales
  useEffect(() => {
    setCurrentPagePlanes(0);
  }, [
    searchPlanes,
    lineaPlanesSeleccionada,
    nivelRiesgoSeleccionado,
    grupoPlanSeleccionado,
  ]);

  // Adjust date range based on search input for Solicitudes
  useEffect(() => {
    if (search === "") {
      setFechaDesde(calculateDate(new Date(), -30));
    } else {
      setFechaDesde(new Date("2024-08-02"));
      setFechaHasta(new Date());
    }
  }, [search]);

  // Adjust date range based on search input for Análisis
  useEffect(() => {
    if (searchAnalisis === "") {
      setFechaDesdeUpdate(calculateDate(new Date(), -30));
    } else {
      setFechaDesdeUpdate(new Date("2024-08-02"));
      setFechaHastaUpdate(new Date());
    }
  }, [searchAnalisis]);

  // Handle date changes for Solicitudes
  const handleChangeInterval = (value: number | null) => {
    setFechaDesde(calculateDate(new Date(), value));
    setFechaHasta(new Date());
  };

  const handleChangeStartDate = (date: string) => {
    setFechaDesde(date ? new Date(date) : calculateDate(new Date(), -30));
  };

  const handleChangeEndDate = (date: string) => {
    setFechaHasta(date ? new Date(date) : new Date());
  };

  // Handle date changes for Update for Análisis
  const handleChangeIntervalUpdate = (value: number | null) => {
    setFechaDesdeUpdate(calculateDate(new Date(), value));
    setFechaHastaUpdate(new Date());
  };

  const handleChangeStartDateUpdate = (date: string) => {
    setFechaDesdeUpdate(date ? new Date(date) : calculateDate(new Date(), -30));
  };

  const handleChangeEndDateUpdate = (date: string) => {
    setFechaHastaUpdate(date ? new Date(date) : new Date());
  };

  // Handle pagination changes for Cadenas
  const onPageChangeCadenas = (e: any, n: number) => {
    setCurrentPageCadenas(n);
  };

  const onRowsPerPageChangeCadenas = (e: any) => {
    setRowsPerPageCadenas(parseInt(e.target.value, 10));
    setCurrentPageCadenas(0);
  };

  // Handle pagination changes for Solicitudes
  const onPageChange = (e: any, n: number) => {
    setCurrentPage(n);
  };

  const onRowsPerPageChange = (e: any) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  // Handle pagination changes for Análisis
  const onPageChangeAnalisis = (e: any, n: number) => {
    setCurrentPageAnalisis(n);
  };

  const onRowsPerPageChangeAnalisis = (e: any) => {
    setRowsPerPageAnalisis(parseInt(e.target.value, 10));
    setCurrentPageAnalisis(0);
  };

  // Handlers pagination for Planes Comerciales
  const onPageChangePlanes = (e: any, n: number) => {
    setCurrentPagePlanes(n);
  };

  const onRowsPerPageChangePlanes = (e: any) => {
    setRowsPerPagePlanes(parseInt(e.target.value, 10));
    setCurrentPagePlanes(0);
  };

  // State for fechaLoteSeleccionada
  const [fechaLoteSeleccionada, setFechaLoteSeleccionada] =
    useState<string>("hoy");

  // State for cadenaSeleccionada
  const [cadenaSeleccionada, setCadenaSeleccionada] =
    useState<IListItem | null>({ value: 0, label: "Todas" });

  return (
    <FiltrosContext.Provider
      value={{
        search,
        setSearch,
        fechaDesde,
        fechaHasta,
        estadoSolicitud,
        fechaEstado,
        provincia,
        setProvincia,
        currentPage,
        rowsPerPage,
        setFechaDesde,
        setFechaHasta,
        setEstadoSolicitud,
        setFechaEstado,
        setCurrentPage,
        setRowsPerPage,
        handleChangeInterval,
        handleChangeStartDate,
        handleChangeEndDate,
        onPageChange,
        onRowsPerPageChange,
        ITEMS_PER_PAGE,
        fechaLoteSeleccionada,
        setFechaLoteSeleccionada,
        cadenaSeleccionada,
        setCadenaSeleccionada,
        retailerSeleccionada,
        setRetailerSeleccionada,
        fechaDesdeUpdate,
        fechaHastaUpdate,
        setFechaDesdeUpdate,
        setFechaHastaUpdate,
        handleChangeIntervalUpdate,
        handleChangeStartDateUpdate,
        handleChangeEndDateUpdate,
        searchAnalisis,
        setSearchAnalisis,
        ITEMS_PER_PAGE_ANALISIS,
        onPageChangeAnalisis,
        onRowsPerPageChangeAnalisis,
        currentPageAnalisis,
        rowsPerPageAnalisis,
        searchPlanes,
        setSearchPlanes,
        lineaPlanesSeleccionada,
        setLineaPlanesSeleccionada,
        nivelRiesgoSeleccionado,
        setNivelRiesgoSeleccionado,
        grupoPlanSeleccionado,
        setGrupoPlanSeleccionado,
        currentPagePlanes,
        setCurrentPagePlanes,
        rowsPerPagePlanes,
        setRowsPerPagePlanes,
        onPageChangePlanes,
        onRowsPerPageChangePlanes,
        ITEMS_PER_PAGE_PLANES,
        searchCadenas,
        setSearchCadenas,
        retailerSeleccionadaCadenas,
        setRetailerSeleccionadaCadenas,
        ITEMS_PER_PAGE_CADENAS,
        currentPageCadenas,
        rowsPerPageCadenas,
        setCurrentPageCadenas,
        setRowsPerPageCadenas,
        onPageChangeCadenas,
        onRowsPerPageChangeCadenas,
      }}
    >
      {children}
    </FiltrosContext.Provider>
  );
};

export const useFiltrosContext = () => {
  const context = useContext(FiltrosContext);
  if (!context) {
    throw new Error("useFiltrosContext must be used within a FiltrosProvider");
  }
  return context;
};
